export {
  getOffersForProject,
  getIndexForOfferThatImpactsClosestTo100People,
  getOfferById,
  getPifProjects,
} from './PifService'
export type { Offer, Perk } from './PifService'
